export default __webpack_public_path__ + "static/media/wallet-finish.3d4d4086.png";